<H1> Measurements<app-loader [status]="loaderStatus"></app-loader></H1>
<div style="overflow-x:auto;">
<table >
<div *ngFor='let in of counter(255) ;let i = index'>
<app-meting-item [fullChannelNumber] = "i" ></app-meting-item>
</div>
</table>
</div>
